import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a4b867a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
import { queryAllApps, queryAllUsers } from '@/api/permission';
import { useStore } from '@/store';
import RightModal from '@/views/permissionManage/components/RightModal.vue';
import { useUser } from '@/views/permissionManage/useUser';
import DetailModal from "@/views/permissionManage/components/DetailModal.vue";
import { reportEvent } from "@/common";
export default /*#__PURE__*/_defineComponent({
  __name: 'AppTableBlock',
  setup(__props, {
    expose
  }) {
    const {
      allApps
    } = useUser();
    const columns = [{
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      width: 120
    }, {
      title: '账号',
      dataIndex: 'username',
      key: 'username',
      width: 150
    }, {
      title: '用户名',
      dataIndex: 'name',
      key: 'name',
      width: 150
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const dataSource = ref([]),
      pageIndex = ref(1),
      pageSize = ref(20),
      pageTotal = ref(100),
      searchObj = ref({}),
      tableRef = ref(),
      rightVisible = ref(false),
      detailVisible = ref(false),
      editItem = ref();
    const getUserList = async () => {
        let startTime = new Date().getTime();
        let params = {
          currentPage: pageIndex.value,
          pageSize: pageSize.value
        };
        Object.keys(searchObj.value).forEach(item => {
          if (searchObj.value[item] || searchObj.value[item] === 0) {
            params = {
              ...params,
              [item]: searchObj.value[item]
            };
          }
        });
        try {
          const {
            userCount,
            pageUserInfo,
            code
          } = await queryAllUsers(params);
          if (code === '0000') {
            pageTotal.value = userCount;
            dataSource.value = pageUserInfo;
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '应用权限',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'succeed'
              }
            });
          } else {
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '应用权限',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'failed'
              }
            });
          }
        } catch (e) {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '应用权限',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      },
      searchUser = async obj => {
        pageIndex.value = 1;
        searchObj.value = obj;
        await getUserList();
      },
      changePage = async (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        await getUserList();
      },
      openModal = item => {
        checkDetail(item);
        rightVisible.value = true;
      },
      openDetail = item => {
        checkDetail(item);
        detailVisible.value = true;
      },
      checkDetail = async item => {
        editItem.value = item;
        try {
          const {
            code,
            data
          } = await queryAllApps({
            userId: item.id
          });
          if (code === '0') {
            let arr = data;
            editItem.value = {
              ...editItem.value,
              permId: arr.map(i => i.dbtid).join(','),
              appNameList: arr.map(i => i.dbtName).join(',')
            };
          }
        } catch (e) {}
      };
    onMounted(async () => {
      await getUserList();
    });
    expose({
      searchUser
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "userId",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref2;
          return [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openDetail(record)
          }, {
            default: _withCtx(() => [_createTextVNode("权限详情")]),
            _: 2
          }, 1032, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            class: "per-btn",
            type: "link",
            onClick: $event => openModal(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 权限管理 ")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_permission, {
            permissionValue: 'app',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]])], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": ""
      }, null, 8, ["current", "pageSize", "total"]), _createVNode(RightModal, {
        "model-visible": rightVisible.value,
        "onUpdate:model-visible": _cache[2] || (_cache[2] = $event => rightVisible.value = $event),
        "perm-list": _unref(allApps),
        "edit-item": editItem.value,
        "onUpdate:edit-item": _cache[3] || (_cache[3] = $event => editItem.value = $event),
        type: "app",
        onUpdateData: getUserList
      }, null, 8, ["model-visible", "perm-list", "edit-item"]), _createVNode(DetailModal, {
        "model-visible": detailVisible.value,
        "onUpdate:model-visible": _cache[4] || (_cache[4] = $event => detailVisible.value = $event),
        "edit-item": editItem.value
      }, null, 8, ["model-visible", "edit-item"])]);
    };
  }
});